package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_task_domain_di_TaskUseCaseModule : Module get() = module {
	single() { _ -> com.essntl.features.task.domain.use_case.AddTaskUseCase(taskRepository=get(),toastManager=get()) } 
	single() { _ -> com.essntl.features.task.domain.use_case.DeleteTaskUseCase(taskRepository=get(),toastManager=get()) } 
	single() { _ -> com.essntl.features.task.domain.use_case.UpdateTaskUseCase(taskRepository=get(),toastManager=get()) } 
}
public val com.essntl.features.task.domain.di.TaskUseCaseModule.module : org.koin.core.module.Module get() = com_essntl_features_task_domain_di_TaskUseCaseModule
